<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
             <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/event_production/bg_cost-savings.jpg" alt=""></transition></div>
              <div class="page-content content">
                <transition name="slide-fade" mode="out-in" appear>
                  <TitleContent h2="Event Production" h1="Cost Savings" />                    
                </transition>
                <transition name="slide-fade" mode="out-in" appear>
                  <div class="text-content">
                      <p class='large'>Allegiant Stadium was designed to efficiently move between sports and entertainment. Having a removable field tray allows the stadium to be steel-ready when tours arrive. The drivable stadium floor requires no field cover or field damage contingency, which is estimated to save tours up to two days of labor and upwards of <span class="yellow">$400K in expenses.</span></p>
                      <Feature inPageBottom yellowLabel label="$150K<br/>Savings" description="In field cover protection<br/>rental costs & labor" icon="event_production/icon_dollar.svg" />
                      <Feature inPageBottom label="Save Up To<br/>2 Days" description="of load in/out labor<br/>costs & time" icon="event_production/icon_calendar.svg" />
                      <Feature inPageBottom label="No field damage<br/>contingency necessary" description="" icon="event_production/icon_alert.svg" />
                  </div>                    
                </transition>
              </div>
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>

import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Feature from "@/patterns/Feature.vue";
export default {
  name: "CostSavings",
  components: { PageBottom, TitleContent, Feature },
  data: () => ({
    scrollContent: false,
    videoStyle: {}    
  }),  
  mounted() {    
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  }, 
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    }
  },
};
</script>
<style lang="scss" scoped>
.large {
  display:inline-block;
  max-width: 40vw;
  margin-right:25px;
  margin-top:0;
}
</style>
